import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SmartBannerLib from 'smart-app-banner';
import 'smart-app-banner/dist/smart-app-banner.css';
import './SmartBanner.css';

const SmartBanner = () => {
  const { t } = useTranslation('views');

  useEffect(() => {
    const buttonText = t('smartBanner.buttonText');
    const finalPrice = t('smartBanner.price');
    const store = t('smartBanner.store');
    const author = t('smartBanner.author');
    const title = t('smartBanner.title');
    const banner = new SmartBannerLib({
      daysHidden: 15,
      daysReminder: 90,
      title,
      author,
      button: buttonText,
      store: {
        ios: store,
        android: store,
      },
      price: {
        ios: finalPrice,
        android: finalPrice,
      },
    });

    return () => {
      if (banner && typeof banner.hide === 'function') {
        banner.hide();
      }
    };
  }, [t]);

  // This component doesn't render anything directly
  // The smart-app-banner library handles DOM manipulation
  return null;
};

export default SmartBanner;
